<template>
  <textarea
    v-model="model"
    v-focus="hasFocus"
  ></textarea>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';

export default {
  mixins: [focusable],

  props: {
    modelValue: String
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get: ({ modelValue }) => modelValue,

      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  }
};
</script>
